var exports = {
  "ns": "Attachment.module__attachmentWrapper___YzRiVH",
  "yf": "Attachment.module__expiredOverlay___YzRiVH",
  "ri": "Attachment.module__expiredContent___YzRiVH",
};

module.exports = exports;
